module.exports = __webpack_public_path__ + "static/media/Usual-Bold.da8cd87b.ttf";